// ============================================================
// 打字机循环：Hero 提示语（开机完成后启动）
// ============================================================

const LINES = [
  "正在渲染：属于你的 AI 电影…",
  "正在生成：8K 高清 AI 图像…",
  "正在作曲：赛博电子 × 东方韵律…",
  "就绪。导演，请下令。",
];

const TYPE_MS = 68;
const HOLD_MS = 1400;
const DELETE_MS = 26;
const START_DELAY = 250;

export default function initTyping() {
  const el = document.getElementById("hero-typed");
  if (!el) return;

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduced) {
    el.textContent = LINES[0];
    return;
  }

  let lineIndex = 0;
  let charIndex = 0;
  let deleting = false;
  let timer = null;

  const step = () => {
    const line = LINES[lineIndex];
    if (!deleting) {
      charIndex += 1;
      el.textContent = line.slice(0, charIndex);
      if (charIndex === line.length) {
        deleting = true;
        timer = setTimeout(step, HOLD_MS);
        return;
      }
      timer = setTimeout(step, TYPE_MS);
    } else {
      charIndex -= 1;
      el.textContent = line.slice(0, charIndex);
      if (charIndex === 0) {
        deleting = false;
        lineIndex = (lineIndex + 1) % LINES.length;
      }
      timer = setTimeout(step, DELETE_MS);
    }
  };

  const start = () => {
    clearTimeout(timer);
    setTimeout(step, START_DELAY);
  };

  // 等待开机序列结束（容错：若事件缺失，兜底启动）
  let booted = false;
  window.addEventListener("jk:booted", () => {
    if (!booted) {
      booted = true;
      start();
    }
  });
  setTimeout(() => {
    if (!booted) {
      booted = true;
      start();
    }
  }, 4200);
}
